var FitFinderV2Widget=function(v){"use strict";var Tt=Object.defineProperty;var It=(v,b,x)=>b in v?Tt(v,b,{enumerable:!0,configurable:!0,writable:!0,value:x}):v[b]=x;var Y=(v,b,x)=>It(v,typeof b!="symbol"?b+"":b,x);/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var ht;const b=globalThis,x=b.ShadowRoot&&(b.ShadyCSS===void 0||b.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,W=Symbol(),Z=new WeakMap;let J=class{constructor(t,e,i){if(this._$cssResult$=!0,i!==W)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o;const e=this.t;if(x&&t===void 0){const i=e!==void 0&&e.length===1;i&&(t=Z.get(e)),t===void 0&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),i&&Z.set(e,t))}return t}toString(){return this.cssText}};const pt=a=>new J(typeof a=="string"?a:a+"",void 0,W),ut=(a,...t)=>{const e=a.length===1?a[0]:t.reduce((i,s,r)=>i+(o=>{if(o._$cssResult$===!0)return o.cssText;if(typeof o=="number")return o;throw Error("Value passed to 'css' function must be a 'css' function result: "+o+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+a[r+1],a[0]);return new J(e,a,W)},ft=(a,t)=>{if(x)a.adoptedStyleSheets=t.map(e=>e instanceof CSSStyleSheet?e:e.styleSheet);else for(const e of t){const i=document.createElement("style"),s=b.litNonce;s!==void 0&&i.setAttribute("nonce",s),i.textContent=e.cssText,a.appendChild(i)}},G=x?a=>a:a=>a instanceof CSSStyleSheet?(t=>{let e="";for(const i of t.cssRules)e+=i.cssText;return pt(e)})(a):a;/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:mt,defineProperty:gt,getOwnPropertyDescriptor:bt,getOwnPropertyNames:vt,getOwnPropertySymbols:xt,getPrototypeOf:yt}=Object,y=globalThis,X=y.trustedTypes,$t=X?X.emptyScript:"",L=y.reactiveElementPolyfillSupport,z=(a,t)=>a,j={toAttribute(a,t){switch(t){case Boolean:a=a?$t:null;break;case Object:case Array:a=a==null?a:JSON.stringify(a)}return a},fromAttribute(a,t){let e=a;switch(t){case Boolean:e=a!==null;break;case Number:e=a===null?null:Number(a);break;case Object:case Array:try{e=JSON.parse(a)}catch{e=null}}return e}},Q=(a,t)=>!mt(a,t),tt={attribute:!0,type:String,converter:j,reflect:!1,useDefault:!1,hasChanged:Q};Symbol.metadata??(Symbol.metadata=Symbol("metadata")),y.litPropertyMetadata??(y.litPropertyMetadata=new WeakMap);let C=class extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??(this.l=[])).push(t)}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,e=tt){if(e.state&&(e.attribute=!1),this._$Ei(),this.prototype.hasOwnProperty(t)&&((e=Object.create(e)).wrapped=!0),this.elementProperties.set(t,e),!e.noAccessor){const i=Symbol(),s=this.getPropertyDescriptor(t,i,e);s!==void 0&&gt(this.prototype,t,s)}}static getPropertyDescriptor(t,e,i){const{get:s,set:r}=bt(this.prototype,t)??{get(){return this[e]},set(o){this[e]=o}};return{get:s,set(o){const n=s==null?void 0:s.call(this);r==null||r.call(this,o),this.requestUpdate(t,n,i)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)??tt}static _$Ei(){if(this.hasOwnProperty(z("elementProperties")))return;const t=yt(this);t.finalize(),t.l!==void 0&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties)}static finalize(){if(this.hasOwnProperty(z("finalized")))return;if(this.finalized=!0,this._$Ei(),this.hasOwnProperty(z("properties"))){const e=this.properties,i=[...vt(e),...xt(e)];for(const s of i)this.createProperty(s,e[s])}const t=this[Symbol.metadata];if(t!==null){const e=litPropertyMetadata.get(t);if(e!==void 0)for(const[i,s]of e)this.elementProperties.set(i,s)}this._$Eh=new Map;for(const[e,i]of this.elementProperties){const s=this._$Eu(e,i);s!==void 0&&this._$Eh.set(s,e)}this.elementStyles=this.finalizeStyles(this.styles)}static finalizeStyles(t){const e=[];if(Array.isArray(t)){const i=new Set(t.flat(1/0).reverse());for(const s of i)e.unshift(G(s))}else t!==void 0&&e.push(G(t));return e}static _$Eu(t,e){const i=e.attribute;return i===!1?void 0:typeof i=="string"?i:typeof t=="string"?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Em=null,this._$Ev()}_$Ev(){var t;this._$ES=new Promise(e=>this.enableUpdating=e),this._$AL=new Map,this._$E_(),this.requestUpdate(),(t=this.constructor.l)==null||t.forEach(e=>e(this))}addController(t){var e;(this._$EO??(this._$EO=new Set)).add(t),this.renderRoot!==void 0&&this.isConnected&&((e=t.hostConnected)==null||e.call(t))}removeController(t){var e;(e=this._$EO)==null||e.delete(t)}_$E_(){const t=new Map,e=this.constructor.elementProperties;for(const i of e.keys())this.hasOwnProperty(i)&&(t.set(i,this[i]),delete this[i]);t.size>0&&(this._$Ep=t)}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return ft(t,this.constructor.elementStyles),t}connectedCallback(){var t;this.renderRoot??(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),(t=this._$EO)==null||t.forEach(e=>{var i;return(i=e.hostConnected)==null?void 0:i.call(e)})}enableUpdating(t){}disconnectedCallback(){var t;(t=this._$EO)==null||t.forEach(e=>{var i;return(i=e.hostDisconnected)==null?void 0:i.call(e)})}attributeChangedCallback(t,e,i){this._$AK(t,i)}_$ET(t,e){var r;const i=this.constructor.elementProperties.get(t),s=this.constructor._$Eu(t,i);if(s!==void 0&&i.reflect===!0){const o=(((r=i.converter)==null?void 0:r.toAttribute)!==void 0?i.converter:j).toAttribute(e,i.type);this._$Em=t,o==null?this.removeAttribute(s):this.setAttribute(s,o),this._$Em=null}}_$AK(t,e){var r,o;const i=this.constructor,s=i._$Eh.get(t);if(s!==void 0&&this._$Em!==s){const n=i.getPropertyOptions(s),l=typeof n.converter=="function"?{fromAttribute:n.converter}:((r=n.converter)==null?void 0:r.fromAttribute)!==void 0?n.converter:j;this._$Em=s;const h=l.fromAttribute(e,n.type);this[s]=h??((o=this._$Ej)==null?void 0:o.get(s))??h,this._$Em=null}}requestUpdate(t,e,i){var s;if(t!==void 0){const r=this.constructor,o=this[t];if(i??(i=r.getPropertyOptions(t)),!((i.hasChanged??Q)(o,e)||i.useDefault&&i.reflect&&o===((s=this._$Ej)==null?void 0:s.get(t))&&!this.hasAttribute(r._$Eu(t,i))))return;this.C(t,e,i)}this.isUpdatePending===!1&&(this._$ES=this._$EP())}C(t,e,{useDefault:i,reflect:s,wrapped:r},o){i&&!(this._$Ej??(this._$Ej=new Map)).has(t)&&(this._$Ej.set(t,o??e??this[t]),r!==!0||o!==void 0)||(this._$AL.has(t)||(this.hasUpdated||i||(e=void 0),this._$AL.set(t,e)),s===!0&&this._$Em!==t&&(this._$Eq??(this._$Eq=new Set)).add(t))}async _$EP(){this.isUpdatePending=!0;try{await this._$ES}catch(e){Promise.reject(e)}const t=this.scheduleUpdate();return t!=null&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var i;if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??(this.renderRoot=this.createRenderRoot()),this._$Ep){for(const[r,o]of this._$Ep)this[r]=o;this._$Ep=void 0}const s=this.constructor.elementProperties;if(s.size>0)for(const[r,o]of s){const{wrapped:n}=o,l=this[r];n!==!0||this._$AL.has(r)||l===void 0||this.C(r,void 0,o,l)}}let t=!1;const e=this._$AL;try{t=this.shouldUpdate(e),t?(this.willUpdate(e),(i=this._$EO)==null||i.forEach(s=>{var r;return(r=s.hostUpdate)==null?void 0:r.call(s)}),this.update(e)):this._$EM()}catch(s){throw t=!1,this._$EM(),s}t&&this._$AE(e)}willUpdate(t){}_$AE(t){var e;(e=this._$EO)==null||e.forEach(i=>{var s;return(s=i.hostUpdated)==null?void 0:s.call(i)}),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EM(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return!0}update(t){this._$Eq&&(this._$Eq=this._$Eq.forEach(e=>this._$ET(e,this[e]))),this._$EM()}updated(t){}firstUpdated(t){}};C.elementStyles=[],C.shadowRootOptions={mode:"open"},C[z("elementProperties")]=new Map,C[z("finalized")]=new Map,L==null||L({ReactiveElement:C}),(y.reactiveElementVersions??(y.reactiveElementVersions=[])).push("2.1.1");/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const P=globalThis,D=P.trustedTypes,et=D?D.createPolicy("lit-html",{createHTML:a=>a}):void 0,it="$lit$",$=`lit$${Math.random().toFixed(9).slice(2)}$`,st="?"+$,_t=`<${st}>`,_=document,U=()=>_.createComment(""),T=a=>a===null||typeof a!="object"&&typeof a!="function",B=Array.isArray,wt=a=>B(a)||typeof(a==null?void 0:a[Symbol.iterator])=="function",q=`[ 	
\f\r]`,I=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,ot=/-->/g,rt=/>/g,w=RegExp(`>|${q}(?:([^\\s"'>=/]+)(${q}*=${q}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`,"g"),at=/'/g,nt=/"/g,lt=/^(?:script|style|textarea|title)$/i,St=a=>(t,...e)=>({_$litType$:a,strings:t,values:e}),g=St(1),k=Symbol.for("lit-noChange"),f=Symbol.for("lit-nothing"),dt=new WeakMap,S=_.createTreeWalker(_,129);function ct(a,t){if(!B(a)||!a.hasOwnProperty("raw"))throw Error("invalid template strings array");return et!==void 0?et.createHTML(t):t}const At=(a,t)=>{const e=a.length-1,i=[];let s,r=t===2?"<svg>":t===3?"<math>":"",o=I;for(let n=0;n<e;n++){const l=a[n];let h,p,c=-1,d=0;for(;d<l.length&&(o.lastIndex=d,p=o.exec(l),p!==null);)d=o.lastIndex,o===I?p[1]==="!--"?o=ot:p[1]!==void 0?o=rt:p[2]!==void 0?(lt.test(p[2])&&(s=RegExp("</"+p[2],"g")),o=w):p[3]!==void 0&&(o=w):o===w?p[0]===">"?(o=s??I,c=-1):p[1]===void 0?c=-2:(c=o.lastIndex-p[2].length,h=p[1],o=p[3]===void 0?w:p[3]==='"'?nt:at):o===nt||o===at?o=w:o===ot||o===rt?o=I:(o=w,s=void 0);const u=o===w&&a[n+1].startsWith("/>")?" ":"";r+=o===I?l+_t:c>=0?(i.push(h),l.slice(0,c)+it+l.slice(c)+$+u):l+$+(c===-2?n:u)}return[ct(a,r+(a[e]||"<?>")+(t===2?"</svg>":t===3?"</math>":"")),i]};class O{constructor({strings:t,_$litType$:e},i){let s;this.parts=[];let r=0,o=0;const n=t.length-1,l=this.parts,[h,p]=At(t,e);if(this.el=O.createElement(h,i),S.currentNode=this.el.content,e===2||e===3){const c=this.el.content.firstChild;c.replaceWith(...c.childNodes)}for(;(s=S.nextNode())!==null&&l.length<n;){if(s.nodeType===1){if(s.hasAttributes())for(const c of s.getAttributeNames())if(c.endsWith(it)){const d=p[o++],u=s.getAttribute(c).split($),m=/([.?@])?(.*)/.exec(d);l.push({type:1,index:r,name:m[2],strings:u,ctor:m[1]==="."?kt:m[1]==="?"?Et:m[1]==="@"?zt:M}),s.removeAttribute(c)}else c.startsWith($)&&(l.push({type:6,index:r}),s.removeAttribute(c));if(lt.test(s.tagName)){const c=s.textContent.split($),d=c.length-1;if(d>0){s.textContent=D?D.emptyScript:"";for(let u=0;u<d;u++)s.append(c[u],U()),S.nextNode(),l.push({type:2,index:++r});s.append(c[d],U())}}}else if(s.nodeType===8)if(s.data===st)l.push({type:2,index:r});else{let c=-1;for(;(c=s.data.indexOf($,c+1))!==-1;)l.push({type:7,index:r}),c+=$.length-1}r++}}static createElement(t,e){const i=_.createElement("template");return i.innerHTML=t,i}}function E(a,t,e=a,i){var o,n;if(t===k)return t;let s=i!==void 0?(o=e._$Co)==null?void 0:o[i]:e._$Cl;const r=T(t)?void 0:t._$litDirective$;return(s==null?void 0:s.constructor)!==r&&((n=s==null?void 0:s._$AO)==null||n.call(s,!1),r===void 0?s=void 0:(s=new r(a),s._$AT(a,e,i)),i!==void 0?(e._$Co??(e._$Co=[]))[i]=s:e._$Cl=s),s!==void 0&&(t=E(a,s._$AS(a,t.values),s,i)),t}class Ct{constructor(t,e){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=e}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:e},parts:i}=this._$AD,s=((t==null?void 0:t.creationScope)??_).importNode(e,!0);S.currentNode=s;let r=S.nextNode(),o=0,n=0,l=i[0];for(;l!==void 0;){if(o===l.index){let h;l.type===2?h=new R(r,r.nextSibling,this,t):l.type===1?h=new l.ctor(r,l.name,l.strings,this,t):l.type===6&&(h=new Pt(r,this,t)),this._$AV.push(h),l=i[++n]}o!==(l==null?void 0:l.index)&&(r=S.nextNode(),o++)}return S.currentNode=_,s}p(t){let e=0;for(const i of this._$AV)i!==void 0&&(i.strings!==void 0?(i._$AI(t,i,e),e+=i.strings.length-2):i._$AI(t[e])),e++}}class R{get _$AU(){var t;return((t=this._$AM)==null?void 0:t._$AU)??this._$Cv}constructor(t,e,i,s){this.type=2,this._$AH=f,this._$AN=void 0,this._$AA=t,this._$AB=e,this._$AM=i,this.options=s,this._$Cv=(s==null?void 0:s.isConnected)??!0}get parentNode(){let t=this._$AA.parentNode;const e=this._$AM;return e!==void 0&&(t==null?void 0:t.nodeType)===11&&(t=e.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,e=this){t=E(this,t,e),T(t)?t===f||t==null||t===""?(this._$AH!==f&&this._$AR(),this._$AH=f):t!==this._$AH&&t!==k&&this._(t):t._$litType$!==void 0?this.$(t):t.nodeType!==void 0?this.T(t):wt(t)?this.k(t):this._(t)}O(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.O(t))}_(t){this._$AH!==f&&T(this._$AH)?this._$AA.nextSibling.data=t:this.T(_.createTextNode(t)),this._$AH=t}$(t){var r;const{values:e,_$litType$:i}=t,s=typeof i=="number"?this._$AC(t):(i.el===void 0&&(i.el=O.createElement(ct(i.h,i.h[0]),this.options)),i);if(((r=this._$AH)==null?void 0:r._$AD)===s)this._$AH.p(e);else{const o=new Ct(s,this),n=o.u(this.options);o.p(e),this.T(n),this._$AH=o}}_$AC(t){let e=dt.get(t.strings);return e===void 0&&dt.set(t.strings,e=new O(t)),e}k(t){B(this._$AH)||(this._$AH=[],this._$AR());const e=this._$AH;let i,s=0;for(const r of t)s===e.length?e.push(i=new R(this.O(U()),this.O(U()),this,this.options)):i=e[s],i._$AI(r),s++;s<e.length&&(this._$AR(i&&i._$AB.nextSibling,s),e.length=s)}_$AR(t=this._$AA.nextSibling,e){var i;for((i=this._$AP)==null?void 0:i.call(this,!1,!0,e);t!==this._$AB;){const s=t.nextSibling;t.remove(),t=s}}setConnected(t){var e;this._$AM===void 0&&(this._$Cv=t,(e=this._$AP)==null||e.call(this,t))}}class M{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,e,i,s,r){this.type=1,this._$AH=f,this._$AN=void 0,this.element=t,this.name=e,this._$AM=s,this.options=r,i.length>2||i[0]!==""||i[1]!==""?(this._$AH=Array(i.length-1).fill(new String),this.strings=i):this._$AH=f}_$AI(t,e=this,i,s){const r=this.strings;let o=!1;if(r===void 0)t=E(this,t,e,0),o=!T(t)||t!==this._$AH&&t!==k,o&&(this._$AH=t);else{const n=t;let l,h;for(t=r[0],l=0;l<r.length-1;l++)h=E(this,n[i+l],e,l),h===k&&(h=this._$AH[l]),o||(o=!T(h)||h!==this._$AH[l]),h===f?t=f:t!==f&&(t+=(h??"")+r[l+1]),this._$AH[l]=h}o&&!s&&this.j(t)}j(t){t===f?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"")}}class kt extends M{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===f?void 0:t}}class Et extends M{constructor(){super(...arguments),this.type=4}j(t){this.element.toggleAttribute(this.name,!!t&&t!==f)}}class zt extends M{constructor(t,e,i,s,r){super(t,e,i,s,r),this.type=5}_$AI(t,e=this){if((t=E(this,t,e,0)??f)===k)return;const i=this._$AH,s=t===f&&i!==f||t.capture!==i.capture||t.once!==i.once||t.passive!==i.passive,r=t!==f&&(i===f||s);s&&this.element.removeEventListener(this.name,this,i),r&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){var e;typeof this._$AH=="function"?this._$AH.call(((e=this.options)==null?void 0:e.host)??this.element,t):this._$AH.handleEvent(t)}}class Pt{constructor(t,e,i){this.element=t,this.type=6,this._$AN=void 0,this._$AM=e,this.options=i}get _$AU(){return this._$AM._$AU}_$AI(t){E(this,t)}}const V=P.litHtmlPolyfillSupport;V==null||V(O,R),(P.litHtmlVersions??(P.litHtmlVersions=[])).push("3.3.1");const Ut=(a,t,e)=>{const i=(e==null?void 0:e.renderBefore)??t;let s=i._$litPart$;if(s===void 0){const r=(e==null?void 0:e.renderBefore)??null;i._$litPart$=s=new R(t.insertBefore(U(),r),r,void 0,e??{})}return s._$AI(a),s};/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const A=globalThis;class H extends C{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){var e;const t=super.createRenderRoot();return(e=this.renderOptions).renderBefore??(e.renderBefore=t.firstChild),t}update(t){const e=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=Ut(e,this.renderRoot,this.renderOptions)}connectedCallback(){var t;super.connectedCallback(),(t=this._$Do)==null||t.setConnected(!0)}disconnectedCallback(){var t;super.disconnectedCallback(),(t=this._$Do)==null||t.setConnected(!1)}render(){return k}}H._$litElement$=!0,H.finalized=!0,(ht=A.litElementHydrateSupport)==null||ht.call(A,{LitElement:H});const K=A.litElementPolyfillSupport;K==null||K({LitElement:H}),(A.litElementVersions??(A.litElementVersions=[])).push("4.2.1");class N extends H{constructor(){super(),this.sizeData={},this.productImage="",this.shopDomain="",this.isDev=!1,this.showResult=!1,this.showHelp=!1,this.recommendedProducts=[],this.measurementUnit="in",this.isAddingToCart=!1,this.addingToCartHandle=null,this.hasSearched=!1,this.isResultsCollapsed=!1,this.hasInputsChanged=!1,this.loadSavedData()}connectedCallback(){super.connectedCallback(), this._onLinkClick = this._onLinkClick?.bind(this) || this._onLinkClick.bind(this), this.shadowRoot.addEventListener('click', this._onLinkClick, { capture: true }),document.addEventListener("keydown",this.handleEscapeKey.bind(this)),this.trackEvent("fit_finder_initialized",{has_saved_shoe_size:!!this.shoeSize,has_saved_calf_width:!!this.calfWidth,saved_measurement_unit:this.measurementUnit,will_auto_calculate:!!(this.shoeSize&&this.calfWidth)})}disconnectedCallback(){super.disconnectedCallback(),this.shadowRoot.removeEventListener('click', this._onLinkClick, { capture: true }), document.removeEventListener("keydown",this.handleEscapeKey.bind(this))}handleEscapeKey(t){t.key==="Escape"&&this.showHelp&&this.closeHelp()}handleModalClick(t){t.target.classList.contains("modal-overlay")&&this.closeHelp()}_onLinkClick(e) { const path = e.composedPath ? e.composedPath() : []; const a = path.find(el => el && el.classList && el.classList.contains('product-link')); if (!a) return; const href = a.getAttribute('href'); const isNewTab = e.metaKey || e.ctrlKey || e.button === 1; if (!isNewTab) e.preventDefault(); const handle = a.getAttribute('data-handle') || undefined; const variantFromAttr = a.getAttribute('data-variant-id'); const variantFromList = this.recommendedProducts?.find(p => p.handle === handle)?.variantId; const variantId = variantFromAttr || variantFromList || undefined; const size_property = `${this.shoeSize}US-${this.calfWidth}${this.measurementUnit === 'in' ? 'in' : 'cm'}`; const payload = { _clear: true, event: 'view_product_clicked', fit_finder: { component: 'fit_finder_v2_component', timestamp: new Date().toISOString(), product_handle: handle, product_fit_type: a.getAttribute('data-fit-type') || undefined, is_best_fit: a.getAttribute('data-best-fit') === 'true', variant_id: variantId, size_property, shoe_size: this.shoeSize, calf_width: this.calfWidth, measurement_unit: this.measurementUnit, addToCartLocation: 'fit_finder_pdp' } }; console.log('[FF][DL] push', payload); window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); if (!isNewTab && href) { setTimeout(() => window.location.assign(href), 120); } }updated(t){super.updated(t),t.has("sizeData")&&this.sizeData&&Object.keys(this.sizeData).length>0&&this.autoRecommendIfDataExists()}loadSavedData(){const t=localStorage.getItem("fitfinder-v2-shoe-size"),e=localStorage.getItem("fitfinder-v2-calf-width"),i=localStorage.getItem("fitfinder-v2-measurement-unit")||"in",s=localStorage.getItem("fitfinder-v2-has-searched")==="true",r=localStorage.getItem("fitfinder-v2-results-collapsed")==="true";this.shoeSize=t||"",this.calfWidth=e||"",this.measurementUnit=i,this.hasSearched=s,this.isResultsCollapsed=r,this.hasInputsChanged=!1}autoRecommendIfDataExists(){this.shoeSize&&this.calfWidth&&this.sizeData&&Object.keys(this.sizeData).length>0&&setTimeout(()=>{this.findSize()},100)}saveToLocalStorage(){localStorage.setItem("fitfinder-v2-shoe-size",this.shoeSize),localStorage.setItem("fitfinder-v2-calf-width",this.calfWidth),localStorage.setItem("fitfinder-v2-measurement-unit",this.measurementUnit),localStorage.setItem("fitfinder-v2-has-searched",this.hasSearched.toString()),localStorage.setItem("fitfinder-v2-results-collapsed",this.isResultsCollapsed.toString())}clearLocalStorage(){localStorage.removeItem("fitfinder-v2-shoe-size"),localStorage.removeItem("fitfinder-v2-calf-width"),localStorage.removeItem("fitfinder-v2-measurement-unit"),localStorage.removeItem("fitfinder-v2-has-searched"),localStorage.removeItem("fitfinder-v2-results-collapsed"),this.shoeSize="",this.calfWidth="",this.measurementUnit="in",this.showResult=!1,this.recommendedProducts=[],this.hasSearched=!1,this.isResultsCollapsed=!1,this.hasInputsChanged=!1,this.requestUpdate()}toggleResults(){this.isResultsCollapsed=!this.isResultsCollapsed,this.saveToLocalStorage(),this.requestUpdate()}toggleHelp(){this.showHelp=!this.showHelp,this.requestUpdate()}closeHelp(){this.showHelp=!1,this.requestUpdate()}trackEvent(t,e={}){typeof window<"u"&&window.dataLayer&&window.dataLayer.push({_clear:!0,event:t,fit_finder:{component:"fit_finder_v2_component",timestamp:new Date().toISOString(),...e}})}switchMeasurementUnit(t){const e=parseFloat(this.calfWidth),i=this.measurementUnit;e&&this.measurementUnit!==t&&(t==="cm"&&this.measurementUnit==="in"?this.calfWidth=(e*2.54).toFixed(1):t==="in"&&this.measurementUnit==="cm"&&(this.calfWidth=(e/2.54).toFixed(1)),this.hasInputsChanged=!0),this.measurementUnit=t,this.saveToLocalStorage(),this.showResult&&this.shoeSize&&this.calfWidth&&this.findSize(),this.requestUpdate(),i!==t&&e&&this.trackEvent("measurement_updated",{measurement_type:"calf_width",old_value:e,old_unit:i,new_value:this.calfWidth,new_unit:t,action:"unit_conversion"})}handleInputChange(t){const{name:e,value:i}=t.target,s=this[e];this[e]=i,this.saveToLocalStorage(),this.hasInputsChanged=!0,this.requestUpdate(),e==="shoeSize"&&i&&i!==s?this.trackEvent("measurement_entered",{measurement_type:"shoe_size",measurement_value:i,measurement_unit:"US"}):e==="calfWidth"&&i&&i!==s&&this.trackEvent("measurement_entered",{measurement_type:"calf_width",measurement_value:i,measurement_unit:this.measurementUnit})}handleSubmit(t){t.preventDefault(),this.hasSearched=!0,this.hasInputsChanged=!1,this.saveToLocalStorage(),this.trackEvent("fit_calculation_started",{shoe_size:this.shoeSize,calf_width:this.calfWidth,measurement_unit:this.measurementUnit}),this.findSize()}getCurrentProductHandle(){const e=window.location.pathname.match(/\/products\/([^\/]+)/);return e?e[1]:null}isOnCorrectProductPage(t){return this.getCurrentProductHandle()===t}convertToInches(t){return this.measurementUnit==="cm"?t/2.54:t}formatMeasurement(t,e=null){const i=e||this.measurementUnit;let s=t;return i==="cm"&&this.measurementUnit==="in"?s=(t*2.54).toFixed(1):i==="in"&&this.measurementUnit==="cm"&&(s=(t/2.54).toFixed(1)),`${s}${i==="in"?'"':"cm"}`}formatProductMeasurement(t){return this.measurementUnit==="cm"?`${(t*2.54).toFixed(1)}cm`:`${t}"`}getFitType(t,e){const i=e-t;return i<0?"no-fit":i<=.2?"tight-fit":i<=.5?"good-fit":"roomy-fit"}getFitLabel(t){switch(t){case"no-fit":return"- Too small for your calf";case"tight-fit":return"Tight for your calf";case"good-fit":return"Roomy for your calf";case"roomy-fit":return"+ Roomy for your calf";default:return""}}async fetchProductByHandle(t){if(!this.shopDomain)return console.error("Shop domain is required"),null;try{const e=await fetch(`https://${this.shopDomain}/products/${t}.js`);if(!e.ok)return console.error("Product not found:",e.status),null;const i=await e.json();return console.log("Product data:",i),i||null}catch(e){return console.error("Error fetching product:",e),null}}async addToCart(t){if(t){this.isAddingToCart=!0,this.requestUpdate();try{window.__ff_atc_origin = 'Fit Finder'; const e=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:t,quantity:1,properties:{_size:`${this.shoeSize}US-${this.calfWidth}${this.measurementUnit==="in"?"in":"cm"}`}}]})});if(!e.ok)throw new Error(`Cart add failed: ${e.status}`);const i=await e.json();console.log("Added to cart:",i),this.trackEvent("add_to_cart_completed",{variant_id:t,shoe_size:this.shoeSize,calf_width:this.calfWidth,measurement_unit:this.measurementUnit,size_property:`${this.shoeSize}US-${this.calfWidth}${this.measurementUnit==="in"?"in":"cm"}`}),this.showAddedToCartFeedback()}catch(e){console.error("Error adding to cart:",e),alert("Failed to add to cart. Please try again.")}finally{this.isAddingToCart=!1,this.addingToCartHandle=null,this.requestUpdate()}}}showAddedToCartFeedback(){if(window._cartRefresh)window._cartRefresh().then(()=>{const t=document.getElementById("cart-icon-bubble");t?t.click():console.log("Cart icon not found, item added to cart successfully")});else{const t=document.getElementById("cart-icon-bubble");t?t.click():console.log("Cart icon not found, item added to cart successfully")}}async handleAddToCart(t){try{this.addingToCartHandle=t,this.requestUpdate();const e=this.recommendedProducts.find(i=>i.handle===t);if(!e){console.error("Product not found in recommendations");return}if(!e.available){alert("Sorry, this size is currently out of stock.");return}if(this.trackEvent("add_to_cart_started",{product_handle:t,product_fit_type:e.fitType,is_best_fit:e.isBestFit||!1,shoe_size:this.shoeSize,calf_width:this.calfWidth,measurement_unit:this.measurementUnit,variant_id:e.variantId}),e.variantId)await this.addToCart(e.variantId);else{let s=function(n){if(!n)return null;const l=n.toString().match(/[\d.]+/);return l?l[0]:null};const i=await this.fetchProductByHandle(t);if(!i){console.error("Could not fetch product for add to cart");return}const r=parseFloat(s(this.shoeSize));let o=i.variants.find(n=>parseFloat(s(n.option2)).toFixed(1)===r.toFixed(1));if(o||(o=i.variants.find(n=>parseFloat(s(n.option1)).toFixed(1)===r.toFixed(1))),o||(o=i.variants.find(n=>parseFloat(s(n.option3)).toFixed(1)===r.toFixed(1))),!o){alert("Sorry, this size is not available.");return}await this.addToCart(o.id)}}catch(e){console.error("Error handling add to cart:",e),this.trackEvent("add_to_cart_failed",{product_handle:t,error_message:e.message,shoe_size:this.shoeSize,calf_width:this.calfWidth,measurement_unit:this.measurementUnit})}}async checkVariantAvailability(t,e){try{let s=function(n){if(!n)return null;const l=n.toString().match(/[\d.]+/);return l?l[0]:null};const i=await this.fetchProductByHandle(t);if(!i)return console.log(`Product not found: ${t}`),{available:!1,soldOut:!0};console.log(`Checking availability for ${t}, size ${e}`),console.log("Available variants:",i.variants.map(n=>({id:n.id,title:n.title,option1:n.option1,option2:n.option2,option3:n.option3,available:n.available})));const r=parseFloat(s(e));let o=null;return o=i.variants.find(n=>parseFloat(s(n.option2)).toFixed(1)===r.toFixed(1)),o||(o=i.variants.find(n=>parseFloat(s(n.option1)).toFixed(1)===r.toFixed(1))),o||(o=i.variants.find(n=>parseFloat(s(n.option3)).toFixed(1)===r.toFixed(1))),o?(console.log("Found variant:",o),{available:o.available,soldOut:!o.available,variantId:o.id}):(console.log(`No variant found for size ${e} in product ${t}`),{available:!0,soldOut:!1,variantId:null})}catch(i){return console.error("Error checking variant availability:",i),{available:!0,soldOut:!1,variantId:null}}}async findSize(){const t=this.shoeSize,e=parseFloat(this.calfWidth),i=this.convertToInches(e);if(this.showResult=!1,this.recommendedProducts=[],!t||!e){this.showResult=!1;return}const s=t.toString();if(!this.sizeData[s]){this.showResult=!1;return}const r=this.sizeData[s],o=await Promise.all(r.map(async d=>{const u=this.getFitType(i,d.width);console.log(`Product ${d.handle}: fitType=${u}`);const m=await this.checkVariantAvailability(d.handle,t);return console.log(`Product ${d.handle}: available=${m.available}, soldOut=${m.soldOut}`),{...d,fitType:u,fitLabel:this.getFitLabel(u),...m}}));this.recommendedProducts=o;const n=this.recommendedProducts.filter(d=>d.fitType!=="no-fit");let l=null;n.length>0&&(l=n.reduce((d,u)=>{const m=d.width-i,F=u.width-i;return m<0&&F>=0?u:F<0&&m>=0?d:m<0&&F<0?m>F?d:u:m<F?d:u}),l.isBestFit=!0,l.extraRoom=l.width-i);const h={"good-fit":0,"tight-fit":1,"roomy-fit":2,"no-fit":3};this.recommendedProducts.sort((d,u)=>d.isBestFit?-1:u.isBestFit?1:h[d.fitType]-h[u.fitType]),this.recommendedProducts=this.recommendedProducts.slice(0,3),this.showResult=!0,this.requestUpdate();const p=this.recommendedProducts.find(d=>d.isBestFit),c=this.recommendedProducts.filter(d=>d.fitType!=="no-fit");this.trackEvent("fit_calculation_completed",{shoe_size:this.shoeSize,calf_width:this.calfWidth,measurement_unit:this.measurementUnit,best_fit_product:p==null?void 0:p.handle,best_fit_type:p==null?void 0:p.fitType,fitting_products_count:c.length,total_products:this.recommendedProducts.length,products_shown:this.recommendedProducts.map(d=>({handle:d.handle,fit_type:d.fitType,is_best_fit:d.isBestFit||!1,available:d.available}))})}formatProductName(t){return t.replace(/-/g," ").replace(/\b\w/g,e=>e.toUpperCase())}getAvailableSizes(){return!this.sizeData||Object.keys(this.sizeData).length===0?[]:Object.keys(this.sizeData).sort((t,e)=>parseFloat(t)-parseFloat(e))}getInputRange(){return this.measurementUnit==="in"?{min:10,max:25,step:.1}:{min:25,max:65,step:.1}}renderFeaturedCard(t){const e=this.formatProductName(t.handle),i=this.formatProductMeasurement(t.width);return this.formatProductMeasurement(t.extraRoom),g`
      <div class="featured-card ${this.isResultsCollapsed?"collapsed":""}">
        <div class="featured-badge">Your Perfect Fit</div>
        
        ${this.productImage?g`
          <img src="${this.productImage}" alt="${e}" class="product-image">
        `:""}
        
        <h4 class="product-title">${e}</h4>
        <div class="product-specs-container">
          <div class="product-specs-item">
          CALF WIDTH<br>
          <span class="product-specs-value">${i}</span>
          </div>
          <div class="product-specs-item">
          SHOE SIZE<br>
          <span class="product-specs-value">${this.shoeSize} (US)</span>
          </div>
        </div>
        
        <div class="button-container">
          ${this.isOnCorrectProductPage(t.handle)?"":g`
            <a href="/products/${t.handle}" 
            class="product-link"
            data-handle="${t.handle}"
            data-fit-type="${t.fitType || ''}"
            data-best-fit="${!!t.isBestFit}"
            data-variant-id="${t.variantId || ''}"
            >
              VIEW PRODUCT
            </a>
          `}
          <button 
            class="add-to-cart-btn" 
            @click=${()=>this.handleAddToCart(t.handle)}
            ?disabled=${this.addingToCartHandle===t.handle||t.soldOut}
          >
            ${this.addingToCartHandle===t.handle?"ADDING...":t.soldOut?"SOLD OUT":"ADD TO CART"}
          </button>
        </div>
      </div>
    `}renderProductCard(t){const e=this.formatProductName(t.handle);this.isOnCorrectProductPage(t.handle),this.formatMeasurement(this.calfWidth);const i=this.formatProductMeasurement(t.width);return g`
      <div class="product-card ${t.fitType}">
        <div class="fit-indicator ${t.fitType}">
          ${t.fitLabel}
        </div>
        
        ${this.productImage?g`
          <img src="${this.productImage}" alt="${e}" class="product-image">
        `:""}
        
        <div class="product-details">
          <h4 class="product-title">${e}</h4>
          <div class="product-specs-container-sm">
            <div class="product-specs-item">
              CALF WIDTH<br>
              <span class="product-specs-value">${i}</span>
            </div>
            <div class="product-specs-item">
              SHOE SIZE<br>
              <span class="product-specs-value">${this.shoeSize} (US)</span>
            </div>
          </div>
          

        </div>
        <div class="button-container">
          ${this.isOnCorrectProductPage(t.handle)?"":g`
            <a href="/products/${t.handle}" 
            class="product-link"
            data-handle="${t.handle}"
            data-fit-type="${t.fitType || ''}"
            data-best-fit="${!!t.isBestFit}"
            data-variant-id="${t.variantId || ''}"
            >
              VIEW PRODUCT
            </a>
          `}
          <button 
            class="add-to-cart-btn" 
            @click=${()=>this.handleAddToCart(t.handle)}
            ?disabled=${this.addingToCartHandle===t.handle||t.soldOut}
          >
            ${this.addingToCartHandle===t.handle?"ADDING...":t.soldOut?"SOLD OUT":"ADD TO CART"}
          </button>
        </div>
      </div>
    `}render(){const t=this.getAvailableSizes(),e=this.getInputRange(),i=this.measurementUnit==="in"?"inches":"centimeters";return g`
      <div class="size-finder">
        <h3>FIND YOUR FIT</h3>
        <form @submit=${this.handleSubmit}>
        <div class="form-container">
          <div class="form-group">
            <label for="shoeSize">Shoe Size (US)</label>
            <select 
              id="shoeSize" 
              name="shoeSize" 
              .value=${this.shoeSize}
              @change=${this.handleInputChange}
              required
            >
              <option value="">Select Size</option>
              ${t.map(s=>g`
                <option value="${s}" ?selected=${this.shoeSize===s}>
                  ${s}
                </option>
              `)}
            </select>
          </div>
          
          <div class="form-group">
            <div class="label-with-help">
              <label for="calfWidth" style="margin-bottom: 0; font-weight: bold; color: #555;">
                Calf Width
              </label>
              <div class="help-icon" @click=${this.toggleHelp} title="How to measure your calf">
                ?
              </div>
            </div>

            <div class="input-with-toggle">
              <input 
                type="number" 
                id="calfWidth" 
                name="calfWidth" 
                step="${e.step}" 
                min="${e.min}" 
                max="${e.max}" 
                .value=${this.calfWidth}
                @input=${this.handleInputChange}
                required
              >
              <div class="measurement-toggle">
                <button 
                  type="button"
                  class="measurement-option ${this.measurementUnit==="in"?"active":""}"
                  @click=${()=>this.switchMeasurementUnit("in")}
                >
                  IN
                </button>
                <button 
                  type="button"
                  class="measurement-option ${this.measurementUnit==="cm"?"active":""}"
                  @click=${()=>this.switchMeasurementUnit("cm")}
                >
                  CM
                </button>
              </div>
            </div>
          </div>
          
          </div>
          
          <button type="submit" class="submit-btn ${this.hasSearched&&!this.hasInputsChanged?"disabled":""}" 
                  ?disabled=${this.hasSearched&&!this.hasInputsChanged}>
            CALCULATE
          </button>
        </form>
        
        ${this.showResult&&this.recommendedProducts.length>0?g`
          <!-- Collapse Toggle -->
          <div class="collapse-toggle" @click=${this.toggleResults}>
            <span class="collapse-text">
              ${this.isResultsCollapsed?"Show Results + Compare Fits":"Hide Results"}
            </span>
          </div>
        `:""}

        ${this.showResult&&this.recommendedProducts.length>0?g`
          <div class="result success">
            
            ${this.recommendedProducts.find(s=>s.isBestFit)?this.renderFeaturedCard(this.recommendedProducts.find(s=>s.isBestFit)):""}
            
            ${!this.isResultsCollapsed&&this.recommendedProducts.filter(s=>!s.isBestFit).length>0?g`
              <div class="results-container">
                ${this.recommendedProducts.filter(s=>!s.isBestFit).map(s=>this.renderProductCard(s))}
              </div>
            `:""}
            
            ${this.isResultsCollapsed?"":g`
              <a href="/collections/shoes-boots-booties" class="shop-more-link">
                Shop more boots that fit →
              </a>
            `}
          </div>
        `:""}

        ${this.isDev?g`
          <div class="dev-controls">
            <h4>🔧 Dev Controls</h4>
            <button class="clear-btn" @click=${this.clearLocalStorage}>
              Clear Saved Data
            </button>
          </div>
        `:""}
      </div>

      <!-- Modal Overlay -->
      <div class="modal-overlay ${this.showHelp?"show":""}" @click=${this.handleModalClick}>
        <div class="help-content">
          <button class="close-button" @click=${this.closeHelp}>&times;</button>
          <h4>How to Measure Your Calf</h4>
          
          <video 
            class="measurement-video"
            autoplay 
            muted 
            loop 
            playsinline
            poster=""
          >
            <source src="https://cdn.shopify.com/videos/c/o/v/65c63d65b4364e1ea3b1cf19fb2ea1c9.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          
          <ol style="margin: 0 0 15px 0; padding-left: 20px;">
            <li style="margin-bottom: 8px;">Place your foot flat on the floor</li>
            <li style="margin-bottom: 8px;">Find the widest part of your calf (usually around mid-calf)</li>
            <li style="margin-bottom: 8px;">Wrap a measuring tape around this widest part</li>
            <li style="margin-bottom: 8px;">Make sure the tape is snug but not tight</li>
            <li style="margin-bottom: 8px;">Record the measurement in ${i}</li>
          </ol>
        </div>
      </div>
    `}}return Y(N,"properties",{sizeData:{type:Object},productImage:{type:String},shopDomain:{type:String},isDev:{type:Boolean}}),Y(N,"styles",ut`
    :host {
      display: block;
      width: 100%;
      margin: 20px auto;
      font-family: arimoregular,sans-serif;
    }

    .size-finder {
      padding: 10px;
      border: 1.5px solid #000;
    }
    
    .size-finder h3 {
      text-align: left;
      color: #333;
      margin-bottom: 5px;
      margin-top: 0;
      font-size: 16px;
    }
    
    .form-group {
      margin-bottom: 15px;
      width: 50%;
    }
    
    .form-group label {
      display: block;
      margin-bottom: 3px;
      color: #555;
      font-size: 11px;
    }

    .label-with-help {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 5px;
    }

    .help-icon {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #000;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
      cursor: pointer;
      transition: background-color 0.2s;
      transform: translate(-6px, -8px);
    }

    .help-icon:hover {
      background-color: #000;
      opacity: 0.6;
    }

    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
    }

    .modal-overlay.show {
      opacity: 1;
      visibility: visible;
    }

    .help-content {
      background-color: #fff;
      border: 2px solid #000;
      border-radius: 8px;
      padding: 20px;
      max-width: 400px;
      width: 90%;
      max-height: 80vh;
      overflow-y: auto;
      position: relative;
      font-size: 14px;
      line-height: 1.4;
      transform: scale(0.9);
      transition: transform 0.3s ease;
    }

    .modal-overlay.show .help-content {
      transform: scale(1);
    }

    .help-content h4 {
      margin: 0 0 15px 0;
      color: #000;
      font-size: 16px;
      text-align: center;
    }

    .measurement-video {
      width: 200px;
      height: auto;
      border-radius: 8px;
      margin: 0 auto 15px auto;
      display: block;
      border: 1px solid #ddd;
    }

    @media screen and (max-width: 480px) {
      .measurement-video {
        width: 150px;
      }
    }

    .close-button {
      position: absolute;
      top: 10px;
      right: 15px;
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #666;
      line-height: 1;
      padding: 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .close-button:hover {
      color: #000;
    }

    .measurement-toggle {
      display: flex;
      margin-bottom: 5px;
      background-color: #f0f0f0;
      border: 1px solid #ccc;
      border-radius: 4px;
      overflow: hidden;
      width: fit-content;
    }

    .measurement-option {
      flex: 1;
      padding: 2px 6px;
      font-size: 9px;
      text-align: center;
      cursor: pointer;
      background-color: transparent;
      border: none;
      transition: background-color 0.2s;
      min-width: 20px;
    }

    .measurement-option.active {
      background-color: #000;
      color: white;
    }

    .measurement-option:hover:not(.active) {
      background-color: #e0e0e0;
    }
    
    .form-group input,
    .form-group select {
      width: 100%;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      font-size: 12px;
      box-sizing: border-box;
      height: 36px;
    }

    .input-with-toggle {
      position: relative;
      display: flex;
      align-items: center;
    }

    .input-with-toggle input {
      padding-right: 60px; /* Make room for the toggle buttons */
    }

    .input-with-toggle .measurement-toggle {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      margin: 0;
      background-color: transparent;
      border: none;
      border-radius: 2px;
      overflow: hidden;
      border: 0.5px solid #000;
    }

    .form-group select {
      background-color: white;
      cursor: pointer;
    }
    
    .submit-btn {
      width: 100%;
      padding: 12px;
      background-color: #000;
      color: white;
      border: none;
      font-size: 16px;
      cursor: pointer;
      margin-top: 10px;
      display: block;
    }

    .submit-btn.disabled,
    .submit-btn:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    .result {
      margin-top: 20px;
      display: none;
    }
    
    .result.success,
    .result.error {
      display: block;
    }

    .results-container {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-top: 20px;
    }

    .featured-card {
      border: 1px solid #000;
      padding: 0;
      background-color: #f0f0f0;
      text-align: center;
      margin-bottom: 20px;
      position: relative;
      transition: height 0.3s ease;
    }

    .featured-card.collapsed {
      height: auto;
      overflow: hidden;
    }

    .featured-badge {
      position: absolute;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #000;
      color: white;
      padding: 5px 15px;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      white-space: nowrap;
      transition: opacity 0.3s ease;
    }

    .featured-card.collapsed .featured-badge {
      display: none;
    }

    .featured-card .product-image {
      width: 100%;
      height: 250px;
      object-fit: contain;
      margin: 0 auto 10px auto;
      display: block;
      object-position: top;
      transition: opacity 0.3s ease, height 0.3s ease, margin 0.3s ease;
    }

    .featured-card.collapsed .product-image {
      display: none;
    }

    .featured-card .product-title {
      font-size: 14px;
      line-height: 1.2;
      margin-bottom: 10px;
      transition: margin 0.3s ease;
    }

    .featured-card.collapsed .product-title {
      margin: 15px 0 10px 0;
    }

    .product-title {
      font-size: 12px !important;
      line-height: 1.2;
      margin-bottom: 10px;
    }

    .featured-card .product-specs {
      font-size: 14px;
      margin-bottom: 15px;
      transition: opacity 0.3s ease;
    }

    .featured-card.collapsed .product-specs {
      display: none;
    }

    .featured-card .fit-details {
      font-size: 13px;
      color: #155724;
      background-color: #d4edda;
      font-weight: bold;
      margin-bottom: 15px;
      font-style: italic;
      border: 1px solid #c3e6cb;
      padding: 10px;
      border-radius: 5px;
      transition: opacity 0.3s ease;
    }

    .featured-card.collapsed .fit-details {
      display: none;
    }

    .featured-card .button-container {
      display: flex;
      gap: 10px;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 15px;
      padding: 0 10px 10px 10px;
    }

    .product-card .button-container {
      display: flex;
      gap: 10px;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 0;
      grid-column: 1 / -1;
    }

    .product-card .add-to-cart-btn, .product-card .product-link {
      width: calc(50% - 10px);
      max-width: calc(50% - 10px);
      box-sizing: border-box;
      white-space: nowrap;
      margin-top: 0;
      text-align: center;
    }

    .featured-card .product-link,
    .featured-card .add-to-cart-btn {
      flex: 1;
      min-width: 0;
      padding: 10px 10px;
      font-size: 12px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      box-sizing: border-box;
    }

    .featured-card .button-container:has(> .add-to-cart-btn:only-child) .add-to-cart-btn,
    .product-card .button-container:has(> .add-to-cart-btn:only-child) .add-to-cart-btn {
      width: 100%;
      max-width: 100%;
    }

    @media (max-width: 280px) {
      .featured-card .button-container {
        flex-direction: column;
      }
      
      .featured-card .product-link,
      .featured-card .add-to-cart-btn {
        flex: none;
        width: 100%;
      }
    }

    .product-card {
      border: 1.5px solid #000;
      padding: 40px 15px 15px 15px;
      background-color: #fff;
      display: grid;
      grid-template-columns: calc(33% - 5px) calc(67% - 5px);
      gap: 10px;
      align-items: center;
      position: relative;
      transition: opacity 0.3s ease;
    }

    .product-card.tight-fit {
      border-color: #ff9800;
      background-color: #fff8e1;
    }

    .product-card.good-fit {
      border-color: #4caf50;
      background-color: #e8f5e8;
    }

    .product-card.roomy-fit {
      border-color: #bea993;
      background-color: #f0f0f0;
    }

    .fit-indicator {
      position: absolute;
      top: 8px;
      right: 10px;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 10px;
      font-weight: bold;
      text-transform: uppercase;
    }

    .fit-indicator.tight-fit {
      background-color: #ff9800;
      color: white;
    }

    .fit-indicator.good-fit {
      background-color: #4caf50;
      color: white;
    }

    .fit-indicator.roomy-fit {
      background-color: #bea993;
      color: white;
    }

    .fit-indicator.no-fit {
      background-color: #747576;
      color: white;
    }

    .product-image {
      width: 80px;
      height: 80px;
      object-fit: cover;
      flex-shrink: 0;
      justify-self: center;
    }

    .product-details {
      flex: 1;
    }

    .product-title {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 5px 0;
      color: #000;
    }

    .product-specs-container {
      font-size: 11px;
      color: #666;
      margin: 0 0 10px 0;
      line-height: 1.4;
      display: flex;
      gap: 20px;
      justify-content: center;
    }

    .product-specs-container-sm {
      font-size: 8px;
      color: #666;
      margin: 0 0 10px 0;
      line-height: 1.4;
      display: flex;
      gap: 10px;
      justify-content: flex-start;
    }

    .product-specs-item {
      text-align: center;
    }

    .product-specs-value {
      font-weight: 700;
      color: #000;
      font-size: 16px;
    }

    .product-link {
      display: inline-block;
      padding: 6px 12px;
      background-color: #FFF;
      color: #000;
      text-decoration: none;
      font-size: 11px;
      margin-top: 8px;
      border: 1px solid #000;
    }

    .product-link:hover {
      opacity: 0.8;
    }

    .product-card.no-fit {
      opacity: 0.4;
      background-color: #f5f5f5;
      border-color: ##747576;
    }

    .add-to-cart-btn {
      display: inline-block;
      padding: 6px 12px;
      background-color: #000;
      color: white;
      border: none;
      font-size: 11px;
      margin-top: 8px;
      cursor: pointer;
      text-decoration: none;
      line-height: 19.8px;
    }

    .add-to-cart-btn:hover {
      opacity: 0.8;
    }

    .add-to-cart-btn:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .product-card.no-fit .add-to-cart-btn {
      background-color: #ccc;
    }

    .shop-more-link {
      display: block;
      margin-top: 15px;
      padding: 8px 0;
      text-align: center;
      font-size: 11px;
      color: #666;
      text-decoration: underline;
      border-top: 1px solid #eee;
    }

    .shop-more-link:hover {
      color: #000;
    }

    .current-page-note {
      font-size: 11px;
      color: #666;
      font-style: italic;
      margin-top: 8px;
    }

    .results-header {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
      text-align: center;
      padding: 10px;
      background-color: #f8f8f8;
      border: 1px solid #ddd;
    }

    .dev-controls {
      margin-top: 15px;
      padding: 10px;
      background-color: #fff3cd;
      border: 1px solid #ffeaa7;
      border-radius: 4px;
    }

    .dev-controls h4 {
      margin: 0 0 10px 0;
      color: #856404;
      font-size: 14px;
    }

    .clear-btn {
      padding: 8px 12px;
      background-color: #dc3545;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
    }

    .clear-btn:hover {
      background-color: #c82333;
    }

    .form-container {
      display: flex;
      flex-direction: row;
      gap: 10px;
    }

    .fit-legend {
      display: flex;
      justify-content: space-around;
      margin-bottom: 15px;
      padding: 10px;
      background-color: #f8f8f8;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 10px;
    }

    .legend-color {
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }

    .legend-color.tight-fit { background-color: #ff9800; }
    .legend-color.good-fit { background-color: #4caf50; }
    .legend-color.roomy-fit { background-color: #2196f3; }
    .legend-color.no-fit { background-color: #f44336; }

    .collapse-toggle {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      cursor: pointer;
      text-decoration: underline;
      transition: color 0.3s ease;
    }

    .collapse-toggle:hover {
      color: black;
    }

    .collapse-caret {
      font-size: 14px;
      font-weight: bold;
      transition: transform 0.3s ease;
      margin-right: 8px;
    }

    .collapse-caret.collapsed {
      transform: rotate(90deg);
    }

    .collapse-text {
      font-size: 12px;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .results-section {
      transition: max-height 0.3s ease, opacity 0.3s ease;
      overflow: hidden;
    }

    .results-section.collapsed {
      max-height: 0;
      opacity: 0;
    }

    .measurements-summary {
      display: none;
      padding: 10px;
      background-color: #f0f0f0;
      border: 1px solid #ddd;
      margin-bottom: 10px;
      border-radius: 4px;
    }

    .measurements-summary.show {
      display: block;
    }

    .summary-item {
      display: inline-block;
      margin-right: 15px;
      font-size: 11px;
      color: #666;
    }

    .summary-value {
      font-weight: bold;
      color: #000;
    }


    @media screen and (max-width: 768px) {
      #calfWidth {
        margin-top: -2px;
      }
      
      .add-to-cart-btn, .product-link {
        font-size: 9px !important;
      }
      
      .collapse-text {
        font-size: 10px;
      }
    }
  `),customElements.define("fit-finder-v2-component",N),v.FitFinderV2Component=N,Object.defineProperty(v,Symbol.toStringTag,{value:"Module"}),v}({});
